import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ArcTeamMemberStatusCounts {
  @Field(t => Int)
  awaiting!: number

  @Field(t => Int)
  active!: number

  @Field(t => Int)
  invited!: number

  @Field(t => Int)
  rejected!: number

  @Field(t => Int)
  blocked!: number
}
